module.exports = __webpack_public_path__ + "img/goodneet.0a7bd167.png";